'use strict';
/**
 * Takes an (async) iterable that emits things and returns an async iterable that
 * emits those things in fixed-sized batches.
 *
 * @template T
 * @param {AsyncIterable<T>|Iterable<T>} source
 * @param {number} [size=1]
 * @returns {AsyncIterable<T[]>}
 */

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function batch(_x) {
  return _batch.apply(this, arguments);
}

function _batch() {
  _batch = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
    var size,
        things,
        _iteratorNormalCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        _value,
        thing,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            size = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;

            /** @type {T[]} */
            things = [];

            if (size < 1) {
              size = 1;
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 5;
            _iterator = _asyncIterator(source);

          case 7:
            _context.next = 9;
            return _awaitAsyncGenerator(_iterator.next());

          case 9:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 13;
            return _awaitAsyncGenerator(_step.value);

          case 13:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 26;
              break;
            }

            thing = _value;
            things.push(thing);

          case 17:
            if (!(things.length >= size)) {
              _context.next = 23;
              break;
            }

            _context.next = 20;
            return things.slice(0, size);

          case 20:
            things = things.slice(size);
            _context.next = 17;
            break;

          case 23:
            _iteratorNormalCompletion = true;
            _context.next = 7;
            break;

          case 26:
            _context.next = 32;
            break;

          case 28:
            _context.prev = 28;
            _context.t0 = _context["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 32:
            _context.prev = 32;
            _context.prev = 33;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 37;
              break;
            }

            _context.next = 37;
            return _awaitAsyncGenerator(_iterator.return());

          case 37:
            _context.prev = 37;

            if (!_didIteratorError) {
              _context.next = 40;
              break;
            }

            throw _iteratorError;

          case 40:
            return _context.finish(37);

          case 41:
            return _context.finish(32);

          case 42:
            if (!things.length) {
              _context.next = 48;
              break;
            }

            _context.next = 45;
            return things.slice(0, size);

          case 45:
            things = things.slice(size);
            _context.next = 42;
            break;

          case 48:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 28, 32, 42], [33,, 37, 41]]);
  }));
  return _batch.apply(this, arguments);
}

module.exports = batch;